<div class="selected-documents-menu-container">
  <div class="buttons">
    <button (click)="moveSelectedDocuments()" mat-stroked-button>
      Move
      <mat-icon matTooltip="Move selected documents"> north_east </mat-icon>
    </button>
    <button (click)="copySelectedDocuments()" mat-stroked-button>
      Clone
      <mat-icon matTooltip="Copy selected documents"> content_copy </mat-icon>
    </button>
    <button mat-stroked-button (click)="downloadSelectedDocuments()" [disabled]="selectedDocuments.length !== 1">
      Open Document
      <mat-icon matTooltip="Download selected documents"> download </mat-icon>
    </button>
    <button (click)="confirmRemoveSelectedDocuments()" mat-stroked-button>
      Remove
      <mat-icon matTooltip="Delete selected documents"> delete </mat-icon>
    </button>
  </div>
</div>
